import React, { useCallback } from "react";
import { Dropdown, DropdownBody, DropdownBodyProps, DropdownHover, DropdownHoverProps } from "../../layout";
import { LazyLoadImage, LinkButton } from "../../misc";
import * as WebRoutes from "@travellocal/utils/webRoutes";
import zenscroll from "zenscroll";
import "./AboutDropdown.scss";

// eslint-disable-next-line max-len
const aboutUsImage = "https://resources.travellocal.com/location/593778a0-998e-4fd3-b834-5e73e5000218-1-front-cover-geisha_large.jpg";

const AboutHoverLink: React.FC<DropdownHoverProps> = (props) => {
  return (
    <DropdownHover {...props} mouseOnly>
      <LinkButton to={WebRoutes.aboutHome()} buttonClass="secondary-button" className="heading--4 is-marginless is-paddingless">
        About us
      </LinkButton>
    </DropdownHover>
  );
};

const AboutDropdownBody: React.FC<DropdownBodyProps> = (props) => {
  const tabIndex = props.isVisible ? 0 : -1; // If visible, allow tabbing through links

  // Scroll within the page if 
  const onLinkClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
    const [path, hash] = e.currentTarget.href.split("#");
    if (hash) {
      const element = document.getElementById(hash);
      if (element) {
        zenscroll.intoView(element);
      }
    }
    else {
      zenscroll.toY(0);
    }
  }, [])

  return (
    <DropdownBody {...props} className="about-dropdown__body">
      <div className="columns is-marginless">
        <div className="column is-marginless is-paddingless">
          <LazyLoadImage className="about-dropdown__image" src={aboutUsImage} alt="" />
        </div>

        <div className="column about-dropdown__info">
          <h3>About us</h3>
          <p>Discover more about TravelLocal - who we are, what we do and how we make your perfect holiday possible.</p>
        </div>

        <div className="column about-dropdown__links">
          <ul className="is-marginless">
            <li>
              <LinkButton
                buttonClass="secondary-button"
                className="is-marginless is-paddingless"
                to={WebRoutes.aboutHome()}
                tabIndex={tabIndex}
                onClick={onLinkClick}
              >
                About us
              </LinkButton>
            </li>
            <li>
              <LinkButton
                buttonClass="secondary-button"
                className="is-marginless is-paddingless"
                to={WebRoutes.aboutHowItWorks()}
                tabIndex={tabIndex}
                onClick={onLinkClick}
              >
                How TravelLocal works
              </LinkButton>
            </li>
            <li>
              <LinkButton
                buttonClass="secondary-button"
                className="is-marginless is-paddingless"
                to={WebRoutes.aboutOurStory()}
                tabIndex={tabIndex}
                onClick={onLinkClick}
              >
                Our story
              </LinkButton>
            </li>
            <li>
              <LinkButton
                buttonClass="secondary-button"
                className="is-marginless is-paddingless"
                to={WebRoutes.aboutLocalExperts()}
                tabIndex={tabIndex}
                onClick={onLinkClick}
              >
                Our local experts
              </LinkButton>
            </li>
            <li>
              <LinkButton
                buttonClass="secondary-button"
                className="is-marginless is-paddingless"
                to={WebRoutes.aboutMeetTheTeam()}
                tabIndex={tabIndex}
              >
                Meet the team
              </LinkButton>
            </li>
          </ul>
        </div>
      </div>
    </DropdownBody>
  );
}

/**
 * About us dropdown on the marketing site.
 * 
 * @status development
 */
export const AboutDropdown: React.FC = () => {
  return (
    <Dropdown
      className="about-dropdown"
      Hover={AboutHoverLink}
      Body={AboutDropdownBody}
    />
  );
}
